import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { catchError, map } from 'rxjs/operators';
import { finalize } from 'rxjs/operators';
import { MessageService } from './message.service';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class NotasFiscaisComunicacaoService extends BaseService {
  private emailNFCom = new Subject<{ nfComId: number }>();
  solicitacaoAbrirEnvioEmail = this.emailNFCom.asObservable();

  constructor(private http: HttpClient, private message: MessageService) { super(); }

  imprimirRelatorio(consulta: any) {
    let idToast = this.message.addToast({
      title: 'Emitindo Relatório',
      msg: 'Notas Fiscais Comunicacão',
      showClose: false, timeout: 0, theme: 'bootstrap', closeOther: false
    })
    return this.http
      .post(this.UrlService + 'notasfiscaiscomunicacao/imprimir', consulta, { responseType: 'blob' })
      .pipe(finalize(() => this.message.clear(idToast)))
      .pipe(catchError(super.parseErrorBlob))
  }

  consultar(filtros) {
    return this.http.post(this.UrlService + 'NotasFiscaisComunicacao/Consultar', filtros)
      .pipe(map(super.extractData), catchError(super.serviceError));
  }

  previsualizarNFCom(dados) {
    return this.http.post(this.UrlService + 'NotasFiscaisComunicacao/PrevisualizarNFCom', dados, { responseType: 'blob' })
      .pipe(catchError(super.parseErrorBlob));
  }

  salvar(dados): Observable<number> {
    return this.http.post(this.UrlService + 'NotasFiscaisComunicacao/Salvar', dados)
      .pipe(map(super.extractData), catchError(super.serviceError));
  }

  enviar(nfComId: number): Observable<{ nfComId: number, nfComNum: number }> {
    return this.http.post(this.UrlService + 'NotasFiscaisComunicacao/Enviar', nfComId)
      .pipe(map(super.extractData), catchError(super.serviceError));
  }

  imprimirNFCom(nfComId: number, formato: any) {
    const params = { nfComId, formato };

    return this.http
      .post(this.UrlService + 'NotasFiscaisComunicacao/ImprimirNFCom', params, { responseType: 'blob' })
      .pipe(catchError(super.parseErrorBlob));
  }

  buscarDadosNFCom(nfComId: number) {
    return this.http.get(this.UrlService + `NotasFiscaisComunicacao/${nfComId}`)
      .pipe(map(super.extractData), catchError(super.serviceError));
  }

  salvarRascunho(dados): Observable<number> {
    return this.http.post(this.UrlService + 'NotasFiscaisComunicacao/SalvarRascunho', dados)
      .pipe(map(super.extractData), catchError(super.serviceError));
  }

  buscarEmailsNFCom(nfComId) {
    return this.http.get(this.UrlService + `NotasFiscaisComunicacao/BuscarEmailsNFCom/${nfComId}`)
      .pipe(map(super.extractData)
        , catchError(super.serviceError));
  }

  enviarEmail(nfComId: number, emails: string[]) {
    const dados = { nfComId, emails };
    return this.http.post(this.UrlService + 'NotasFiscaisComunicacao/EnviarEmail', dados)
      .pipe(map(super.extractData), catchError(super.serviceError));
  }

  cancelarNFCom(nfComId: number, motivo: string) {
    const param = { nfComId, motivo };
    return this.http.post(this.UrlService + 'NotasFiscaisComunicacao/cancelar', param)
      .pipe(map(super.extractData), catchError(super.serviceError));
  }

  abrirEnvioEmail(nfComId: number) {
    if (nfComId) {
      this.emailNFCom.next({ nfComId });
    }
  }

  xmlNFComCancelado(nfComId) {
    return this.http
      .post(this.UrlService + 'NotasFiscaisComunicacao/XmlNFComCancelado/', nfComId, { responseType: 'blob' })
      .pipe(catchError(super.parseErrorBlob));
  }
}
